module.exports = __webpack_public_path__ + "static/media/logoBDP.50b04289.png";